import Vue from 'vue'
import Router from 'vue-router'

import Index from './routers/Index'
import Report from './routers/Report'
import Busy from './routers/Busy'
import System from './routers/System'
import Order from './routers/Order'
import AccountManage from './routers/AccountManage'
import FinancialAudit from './routers/FinancialAudit'
import DistributionList from './routers/DistributionList'
import Resource from './routers/Resource'
import Operate from './routers/Operate'
import Finance from './routers/Finance'
import Common from './routers/Common'
import Mall from './routers/Mall'
import AppManage from './routers/AppManage'
import DevManage from './routers/DevManage'
import Tbs from './routers/Tbs'

Vue.use(Router)

var router = new Router({
  routes: assemblyRouters()
});

export default router

function assemblyRouters() {
  let routes = Index
      .concat(Report) // 报表
      .concat(Busy) // 业务
      .concat(System) // 系统
      .concat(Order) // 订单
      .concat(AccountManage) // 财务-账户管理
      .concat(FinancialAudit) // 财务-财务审核（新）
      .concat(DistributionList) // 运营-分销列表
      .concat(Resource) // 资源
      .concat(Operate) // 运营
      .concat(Finance) // 财务
      .concat(Common) // 财务
      .concat(Mall) // 财务
      .concat(AppManage) // 应用管理
      .concat(DevManage) // DevManage
      .concat(Tbs) // 权益优享
  ;
  return routes
}
